import { Component, Input, OnInit } from '@angular/core';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';




@Component({
  selector: 'app-data-view',
  templateUrl: './data-view.component.html',
  styleUrls: [
    '../view-and-export-data.component.css',
    './data-view.component.css',
  ],
})
export class DataViewComponent implements OnInit {
  @Input() data: any;
  multipleData: any;
  keys: any = [];
  labels: any = [];
  layer_id: any = [];
  makeData: any = [];
  active: any = [];
  boundaries: any;
  constructor(
    private sideNavService: SideNavService,
    private mapService: MapServiceService
  ) {
    //
  }

  ngOnInit(): void {
    //

    this.boundaries = this.mapService.mapData.map_data.map_data.layers;

    this.labels = [];
    this.makeData = [];
    if (!this.data.features.length) {
      for (let i = 0; i < this.boundaries.length; i++) {
        if (this.data.features.layer_id == this.boundaries[i].id) {
          for (let j = 0; j < this.boundaries[i].fields.length; j++) {
            this.keys.push(this.boundaries[i].fields[j].id);
          }
        }
        if (this.data.features.layer_id == this.boundaries[i].id) {
          this.showData(this.data.features.layer_id, i);
          // break;
        }
      }
    } else {
      for (let i = 0; i < this.boundaries.length; i++) {
        //new check
        if (this.data.features[0].layer_id == this.boundaries[i].id) {
          for (let j = 0; j < this.boundaries[i].fields.length; j++) {
            this.keys.push(this.boundaries[i].fields[j].id);
          }
        }

        if (this.data.features[0].layer_id == this.boundaries[i].id) {
          this.showData(this.data.features[0].layer_id, i);
        }
      }
    }

    this.sideNavService.layersFeatures = this.data.features;
  }

  showData(id: any, i: any): void {
    this.active = [];
    this.active[i] = true;
    this.labels = [];
    this.layer_id = [];
    this.makeData = [];
    this.keys = [];
    if (!this.data.features.length) {
      this.multipleData = false;
      // this.keys = Object.keys(this.data.features.data);
      for (let i = 0; i < this.boundaries.length; i++) {
        if (
          this.data.features.layer_id.toString() ==
          this.boundaries[i].id.toString()
        ) {
          for (let j = 0; j < this.boundaries[i].fields.length; j++) {
            this.keys.push(this.boundaries[i].fields[j].id);
          }
        }
      }
      if ('label' in this.data.features) {
        this.labels = [];
        this.labels.push(this.data.features.label);
        // console.log(this.data.features.label,"label single")
      }
      // this.sideNavService.layersFeatures = this.makeData;
      if (!this.layer_id.includes(this.data.features.layer_id)) {
        this.layer_id.push(this.data.features.layer_id);
      }

      this.makeData = this.data.features;
    } else {
      this.labels = [];
      for (let i = 0; i < this.data.features.length; i++) {
        this.layer_id.push(this.data.features[i].layer_id);
        if (this.data.features[i].layer_id == id) {
          this.makeData.push(this.data.features[i]);
          // this.keys = Object.keys(this.data.features[i].data);

          for (let j = 0; j < this.boundaries.length; j++) {
            if (
              this.data.features[i].layer_id.toString() ==
              this.boundaries[j].id.toString()
            ) {
              for (let k = 0; k < this.boundaries[j].fields.length; k++) {
                this.keys.push(this.boundaries[j].fields[k].id);
              }
            }
          }

          if ('label' in this.data.features[i]) {
            // console.log(this.data.features[i].label,"label multi")
            this.labels.push(this.data.features[i].label);
          }
        }
      }

      this.multipleData = true;
      // this.sideNavService.layersFeatures = this.makeData;
    }
    //to send complete data
    this.sideNavService.layersFeatures = this.data.features;
  }
}
